import {DurationUnit} from '../data/reportRowModel';

/** `{n}h` / `{n}p`, trimming a trailing `.0` (e.g. 90min -> '1.5h', 480min -> '8p'). Shared by the
 * per-row duration cell (`CellRenderer`) and the group-total footer (`ReportTable`) so both read
 * identically. `minutes` is the stored duration value; the model always divides it by 60 (see
 * `shapeDuration` in `reportRowMapper`), so `minutes` is `unit-value × 60` for both units. */
export function formatDuration(minutes: number, unit: DurationUnit): string {
	const value = minutes / 60;
	const rounded = Math.round(value * 10) / 10;
	const formatted = rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1);
	return unit === 'hours' ? `${formatted}h` : `${formatted}p`;
}
